module.exports = __webpack_public_path__ + "img/run_icon.3bba100a.svg";